<script setup lang="ts">
import { ref } from "vue";

import { FlashMessageInfoStatus } from "@/types/enums";
import type { DockConfiguration } from "@/types/dock";

import { docksStore } from "@/stores/docks";
import { addInfoFull, addErrorBottom } from "@/stores/messages";

import Dialog from "@/components/elements/Dialog.vue";

const props = defineProps({
  dock: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["done"]);

const storage = docksStore();
const dock = ref<DockConfiguration>(props.dock as DockConfiguration);

const dialogFactoryReset = ref();

async function confirmReset() {
  addInfoFull(FlashMessageInfoStatus.SAVING);
  try {
    await storage.factoryReset(dock.value.dock_id);
    addInfoFull(FlashMessageInfoStatus.SUCCESS);
    emit("done");
  } catch (e: any) {
    addErrorBottom(e);
  }
}

</script>
<template>
  <button
    @click="dialogFactoryReset.open()"
    class="button button--danger">
    {{ $t('ui.factory_reset') }}
  </button>

  <Dialog
    @submit="confirmReset"
    icon="fa-thin fa-warning"
    :title="$t('dock.factory_reset.title')"
    :text="$t('dock.factory_reset.description')"
    :submit-text="$t('ui.confirm')"
    :cancel-text="$t('ui.cancel')"
    :warning="true"
    :text-center="true"
    ref="dialogFactoryReset"
  /> 
</template>
